export default __webpack_public_path__ + "static/media/Group 10752.0453075f.svg";